import LogoInput from './LogoInput';

export default LogoInput;
